module.exports = __webpack_public_path__ + "img/Tal_checkImage.a0887d7e.svg";